import { Tooltip } from "primereact/tooltip";
import { Chip } from "primereact/chip";

import { ContentTag } from "sj-ui-toolkit/src/atlas/components";
import { formatElapsedTime } from "sj-ui-toolkit/src/utils";
import { useHideTimeSpent } from "sj-ui-toolkit/src/integrations";

import { useTournamentContext } from "../../../context/TournamentContext";

export default function TournamentContentInfo({
  lessonType,
  title,
  description,
}: {
  lessonType?: string;
  title: string;
  description?: string;
}) {
  const { elapsedTime, maxPoints, attemptsCount } = useTournamentContext();
  const hideTimeSpent = useHideTimeSpent();

  // Build tooltip content from attempts
  const tooltipContent =
    attemptsCount && attemptsCount.length > 0
      ? `${attemptsCount.map(attempt => `Attempt ${attempt.count}: -${attempt.pointsDecrease} pts`).join("\n")}`
      : "No attempts yet";

  return (
    <div data-test-id="lesson-info">
      <div>
        {lessonType && <ContentTag value={lessonType} />}
        <h1 className="atlas-h4 mt-4.5 mb-2">{title}</h1>
        <p>{description}</p>
      </div>
      <div className="flex flex-row mt-6 body-sm">
        {attemptsCount && attemptsCount.length > 0 && (
          <Tooltip target=".tournament-content-points" style={{ whiteSpace: "pre-line" }} />
        )}
        <div className="flex-1 flex flex-col gap-1">
          <div className="text-muted">Max points</div>
          <div>
            <Chip
              data-pr-tooltip={tooltipContent}
              label={String(maxPoints)}
              className="tournament-content-points chip-label body-md"
            />
          </div>
        </div>
        {!hideTimeSpent && (
          <div className="flex-1 flex flex-col gap-1">
            <div className="text-muted">Time elapsed</div>
            <div>
              <Chip className="chip-label body-md" label={formatElapsedTime(elapsedTime)} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
